import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/Sidebar/Sidebar';
import AdminNavbar from '@/components/Navbars/AdminNavbar';
import HeaderStats from '@/components/Headers/HeaderStats';
import FooterAdmin from '@/components/Footers/FooterAdmin';
import CompanyNavbar from '@/components/Navbars/CompanyNavbar';


export default function CompanyLayout() {
  const [open, setOpen] = useState(true);
  return (
    <>
      <Sidebar open={open} setOpen={setOpen} />
      <div className={`relative min-h-screen bg-slate-100 duration-300 ${open ? 'md:ml-64' : 'md:ml-20'}`}>

        {/* <AdminNavbar /> */}
        <CompanyNavbar />
        <div className='relative bg-sky-600 md:pt-52 pb-32 pt-22'></div>
        <div className='px-4 md:px-10 md:mx-auto w-full md:-m-48 mx-auto -m-24'>
          <Outlet />
          <FooterAdmin />
        </div>
      </div>
    </>
  )
}
